import React, { useState, useEffect } from 'react';
import { View, FlatList, StyleSheet } from 'react-native';
import FriendRequestItem from '../friendRequestItem';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';

const styles = StyleSheet.create({
  container: {
    marginBottom: 15,
  },
  contacts: {
    marginRight: theme.CONTAINER_MARGIN,
    marginLeft: 0,
    borderColor: theme.GREY_MEDIUM_COLOR,
  },
  button: {
    marginTop: 80,
    textAlign: 'center',
  },
  alphabet: {
    color: theme.GREEN_WARM_COLOR,
    fontWeight: 'bold',
    paddingTop: 20,
    paddingBottom: 10,
    flex: 1,
  },
  header: {
    flexDirection: 'row-reverse',
    backgroundColor: theme.WHITE_COLOR,
  },
});

export const FriendRequests = ({
  friendRequests,
  onFriendRequestsFetch,
  fetchFriendsAgain,
  currentUser,
  fetchedFriendRequests,
}) => {
  const [friendRequestsFetched, setFriendRequestsFetched] = useState(fetchedFriendRequests);
  const [resquestList, setResquestList] = useState([]);
  const [requestCounter, setRequestCounter] = useState(0);

  useEffect(() => {
    const requests = [
      {
        firstname: 'Requests',
        header: true,
      },
    ];
    friendRequests.forEach((request) => {
      requests.push({
        id: request.id,
        avatar: request.requester.avatar,
        firstname: request.requester.firstname,
        nickname: request.requester.nickname,
        requester: request.requester.id,
        addressee: request.addressee.id,
      });
    });
    setResquestList(requests);
    setRequestCounter(friendRequests.length);
  }, [friendRequests]); // needed to wait until friendlist is passed on correctly

  if (!friendRequestsFetched && friendRequests.length === 0) {
    onFriendRequestsFetch(currentUser.user.id);
    setFriendRequestsFetched(true);
  }
  if (requestCounter.length < 1) {
    return null;
  }

  function callbackAnswerSent(answer) {
    setRequestCounter(requestCounter - 1);

    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    if (answer === 'Accept') {
      wait(500)
        .then(() => fetchFriendsAgain(true))
        .then(() => onFriendRequestsFetch(currentUser.user.id))
        .catch(() => {
          // error -> do nothing
        });
    } else {
      wait(1000)
        .then(() => onFriendRequestsFetch(currentUser.user.id))
        .catch(() => {
          // error -> do nothing
        });
    }
  }

  if (requestCounter > 0) {
    return (
      <View style={styles.container}>
        <FlatList
          style={styles.contacts}
          data={resquestList}
          testID="contacts"
          keyExtractor={(_item, index) => index.toString()}
          // eslint-disable-next-line consistent-return
          renderItem={({ item }) => {
            if (item.header && friendRequests.length > 0) {
              return (
                <View>
                  <View style={styles.header}>
                    <CustomText style={styles.alphabet}>{item.firstname}</CustomText>
                  </View>
                </View>
              );
            }
            if (!item.header) {
              return <FriendRequestItem request={item} callbackAnswerSent={callbackAnswerSent} />;
            }
          }}
        />
      </View>
    );
  }
  return null;
};
